<template>
  <!--
    Used to edit the InstallationConfig that is used in the videoPostprocessing Themes.
  -->
  <div class="installationConfigListItemAdd">
    <LoadingPlaceholder v-if="loading" />
    <template v-else>
      <template v-if="everythingIsAvailable">
        <form>
          <h4 class="mt-2">
            {{ installationName }}
          </h4>
          <hr class="m-0 mb-3">

          <div class="form-group m-form__group row mb-2">
            <label class="col-4 col-form-label col-form-label">{{ $t('theme') }}</label>
            <div class="col-8">
              <select
                v-model="installationConfig.themeId"
                :class="['form-control', { 'is-invalid': this.$validator.errors.has('IntroOutroId') }]"
              >
                <option :value="null">
                  none
                </option>
                <option
                  v-for="(theme, index) in themes"
                  :key="`option${ index }`"
                  :value="theme.id"
                >
                  {{ theme.name }}
                </option>
              </select>
              <span
                v-show="errors.has('ThemeId')"
                class="badge badge-danger"
              >{{ errors.first('ThemeId') }}</span>
            </div>
          </div>

          <div class="form-group m-form__group row mb-2">
            <label class="col-4 col-form-label">{{ $t('installationConfigListItemEditComp.introOutro') }}</label>
            <div class="col-8">
              <select
                v-model="installationConfig.introOutroId"
                :class="['form-control', { 'is-invalid': this.$validator.errors.has('IntroOutroId') }]"
              >
                <option :value="null">
                  none
                </option>
                <option
                  v-for="(introOutro, index) in introOutroList"
                  :key="`option${ index }`"
                  :value="introOutro.id"
                >
                  {{ introOutro.name }}
                </option>
              </select>
              <span
                v-show="errors.has('IntroOutroId')"
                class="badge badge-danger"
              >{{ errors.first('IntroOutroId') }}</span>
            </div>
          </div>

          <button
            class="btn btn-sm btn-primary float-right mb-3"
            @click.prevent="updateInstallationConfig()"
          >
            <font-awesome-icon
              class="mr-1"
              icon="upload"
            />
            <span>
              {{ $t('update') }}
            </span>
          </button>

          <h5 class="mt-4">
            {{ $t('cutConfig') }}
          </h5>
          <hr class="m-0 mb-3">
        </form>

        <InstallationConfigListItemEditCutConfig2InstallationId :installation-config-id="installationConfigId" />
      </template>
      <template v-else>
        {{ $t('noDataAvailable') }}
      </template>
    </template>
  </div>
</template>

<script>
import { errorMixin } from '@/mixins/errorMixin.js';

export default {
  name: "InstallationConfigListItemAdd",
  components: {
    InstallationConfigListItemEditCutConfig2InstallationId: () => import('@/components/VideoPostprocessing/InstallationConfig/InstallationConfigListItemEditCutConfig2InstallationId.vue')
  },
  mixins: [
    errorMixin
  ],
  props: {
    installationConfigId: {
      type: Number,
      required: true
    },
    installationName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      cutConfig2InstallationList: null,
      cutConfigList: null,
      cutConfigId: null,
      introOutroList: null,
      themes: null,
      installationList: null,
      installationConfig: null,
      sortId: null
    }
  },
  computed: {
    everythingIsAvailable: function () {
      if (!this.installationConfig) {
        return false;
      }
      if (!this.themes) {
        return false;
      }
      if (!this.introOutroList) {
        return false;
      }
      if (!this.cutConfig2InstallationList) {
        return false;
      }
      if (!this.cutConfigList) {
        return false;
      }
      return true;
    }
  },
  created () {
    this.getData();
  },
  methods: {
    getData () {
      this.axios.all([
        this.axios.get(`/VideoPostprocessing/GetAllCutConfig2InstallationId`),
        this.axios.get(`/VideoPostprocessing/GetInstallationConfig?id=${ this.installationConfigId }`),
        this.axios.get('/VideoPostprocessing/GetAllCutConfig'),
        this.axios.get('/VideoPostprocessing/GetIntrooutros'),
        this.axios.get('/VideoPostprocessing/GetThemes'),
        this.axios.get('/Installation/GetAll')
      ]).then(this.axios.spread((cutConfig2InstallationIdResponse, installationConfigResponse, getAllCutConfigResponse, introOutroResponse, themeResponse, installationsResponse) => {
          this.cutConfig2InstallationList= cutConfig2InstallationIdResponse.data;
          this.installationConfig = installationConfigResponse.data;
          this.cutConfigList = getAllCutConfigResponse.data;
          this.introOutroList = introOutroResponse.data;
          this.themes = themeResponse.data;
          this.installationList = installationsResponse.data;
        }))
        .finally(() => {
          this.loading = false;
        });
    },
    addCutConfig2InstallationId () {
      this.readyToAdd = ! this.readyToAdd;
    },
    updateInstallationConfig () {
      let installationConfig = {
        'Id': this.installationConfig.id,
        'InstallationId': this.installationConfig.installationId,
        'ThemeId': this.installationConfig.themeId,
        'IntroOutroId': this.installationConfig.introOutroId
      };
      this.axios.post(`/VideoPostprocessing/UpdateInstallationConfig`, installationConfig)
        .then(() => {
          this.error_clear();
          this.$emit('installationConfigListItemEdit_refreshInstallationConfigList');
          this.$snotify.success(this.$t('installationConfigListItemEditComp.successfullyUpdated'));
          this.getData();
        })
        .catch((error) => {
          this.error_clear();
          this.error_validate(error);
        });
    }
  }
}
</script>
